import styled, { css } from 'styled-components/macro';
import { ru } from '../../../assets/icons';

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: #1f2939;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  border-radius: 8px;

  ${({ theme }) => css`
    gap: ${theme.spacings.xs};
  `}
`;

export const PhoneWrapper = styled.div`
  display: flex;
  border: 1px solid #ced5de;
  border-radius: 8px;
  width: 100%;
`;

export const CountryWrapper = styled.div`
  display: flex;
  align-items: center;
  border-right: 1px solid #ced5de;
  padding: 12px 8px 12px 12px;
  border-radius: 8px 0 0 8px;
  cursor: pointer;
  transition: all 150ms;

  :hover {
    background-color: #efefef;
  }
`;

export const CountryBallsWrapper = styled.div`
  display: flex;
  gap: 4px;
  padding: 0;
  align-items: center;
  white-space: nowrap;
`;

export const RuIcon = styled.img.attrs({ src: ru })`
  height: 16px;
  width: 16px;
`;

export const InputWrapper = styled.div<{ isDisabled: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  padding: 12px;
  background-color: #ffffff;
  border-radius: 0 8px 8px 0;
  width: 100%;

  ${(props) =>
    props.isDisabled &&
    css`
      background-color: ${props.theme.colors.gray[100]};
      pointer-events: none;
    `}
`;

export const LoaderWrapper = styled.div`
  position: absolute;
  right: 12px;
`;

export const StyledInput = styled.input<{ isDisabled: boolean }>`
  width: 100%;
  padding: 0;
  outline: none;
  border: none;
  color: #1f2939;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;

  ${(props) =>
    props.isDisabled &&
    css`
      background-color: ${props.theme.colors.gray[100]};
      color: ${props.theme.colors.gray[300]};
      pointer-events: none;
    `}
`;
